export const IMMAPER_MAR_FORM_ADD_CONNECTION = 'IMMAPER_MAR_FORM_ADD_CONNECTION'
export const IMMAPER_MAR_FORM_DELETE_CONNECTION = 'IMMAPER_MAR_FORM_DELETE_CONNECTION'
export const IMMAPER_MAR_FORM_CHANGE_ITINERARY = 'IMMAPER_MAR_FORM_CHANGE_ITINERARY'
export const IMMAPER_MAR_FORM_ONCHANGE = 'IMMAPER_MAR_FORM_ONCHANGE'
export const IMMAPER_MAR_FORM_CHANGE_TRAVEL_DETAIL = 'IMMAPER_MAR_FORM_CHANGE_TRAVEL_DETAIL'
export const IMMAPER_MAR_FORM_ADD_TRAVEL_DETAIL = 'IMMAPER_MAR_FORM_ADD_TRAVEL_DETAIL'
export const IMMAPER_MAR_FORM_DELETE_TRAVEL_DETAIL = 'IMMAPER_MAR_FORM_DELETE_TRAVEL_DETAIL'
export const IMMAPER_MAR_FORM_RESET = 'IMMAPER_MAR_FORM_RESET'
export const MAR_RESET_ITINERARY = 'MAR_RESET_ITINERARY'
export const MAR_RESET_TRAVEL_DETAIL = 'MAR_RESET_TRAVEL_DETAIL'
